import type { UserType } from '../types/user'

export const userInitialValues: UserType = {
  customerType: 'Customer',
  authError: false,
  isSignedIn: false,
  token: null,
  keepSignedIn: false,
  customer: null,
  refID: null,
  refName: null,
  refError: false,
  registered: false,
  storeCredit: null,
  formattedStoreCredit: null,
  rawStoreCredit: null,
  meReferralCode: null,
  creditCardsData: null,
}
